import axios from "axios";
import router from "../router/index";
import { Message } from "element-ui";
// import { Toast } from 'vant'

axios.defaults.timeout = 5000;
// axios.defaults.baseURL = 'https://ptt.inno-cn.cn'
axios.defaults.baseURL = "https://dev.duodraw.cn";

const tip = (msg) => {
    Message({
        message: msg,
        duration: 1000,
        type: "error",
    });
};

// http request 请求拦截器
axios.interceptors.request.use(
    function (config) {
        config.data = JSON.stringify(config.data);
        config.headers = {
            "Content-Type": "application/json",
        };
        // config.headers["huashi-token"] = token.huashiToken;
        // config.headers["huashi-login-device"] = token.huashiLoginDevice;
        // 打印请求信息
        console.log("🚀 请求:", {
            url: config.url,
            method: config.method,
            data: config.data,
            headers: config.headers,
        });

        return config;
    },
    function (err) {
        return Promise.reject(err);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        // 打印响应信息
        console.log("✅ 响应成功:", {
            url: response.config.url,
            status: response.status,
            data: response.data,
            headers: response.headers,
        });
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    (error) => {
        // 打印错误信息
        console.log("❌ 响应错误:", {
            url: error.config?.url,
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
        });
        if (error.response?.status) {
            switch (error.response.status) {
                case 401:
                    tip("身份失效，请重新登录");
                    break;
                case 404:
                    Message({
                        message: "网络请求不存在",
                        duration: 1000,
                        type: "error",
                    });
                    break;
                default:
                    Message({
                        message: error.response.data?.message || "请求失败",
                        duration: 1500,
                        type: "error",
                    });
            }
            return Promise.reject(error.response);
        }
        return Promise.reject(error);
    }
);
export default axios;
